import { authClient } from "./oidcClientFront";
import { THEME_PREFERENCE_KEY } from "../../theme/themePreference";

const API_URL = process.env.REACT_APP_API_URL || '';

export const getCurrentUser = async () => {
  const user = await authClient.getUser();
  console.log("1111111");
  return user && !user.expired ? user : null;
};

export const clearOidcStorage = () => {
  Object.keys(localStorage).forEach(key => {
    if (!key.startsWith("oidc.user") && key !== THEME_PREFERENCE_KEY) {
      localStorage.removeItem(key);
    }
  });
};

export const login = async () => {
  window.location.href = `${API_URL}/auth/login`;
};

export const logout = async () => {
  window.location.href = `${API_URL}/auth/logout`;

  clearOidcStorage();
};

// Бекенд недоступний (стартує/перезапускається): мережева помилка, 5xx або відповідь
// не JSON. Для /api/* у цей час Traefik віддає index.html фронту зі статусом 200 —
// це НЕ «немає сесії», і користувача не можна скидати на вхід.
export class BackendUnavailableError extends Error {
  constructor(reason) {
    super(`Backend unavailable: ${reason}`);
    this.name = 'BackendUnavailableError';
  }
}

export const isJsonResponse = (res) =>
  /\bjson\b/i.test(res.headers?.get?.('content-type') || '');

export const me = async () => {
  let res;
  try {
    res = await fetch(`${API_URL}/auth/me`, {
      method: 'GET',
      credentials: "include"
    });
  } catch (err) {
    throw new BackendUnavailableError('network');
  }
  if (res.status >= 500) {
    throw new BackendUnavailableError(`status ${res.status}`);
  }
  if (!res.ok) {
    return null; // 401 — сесії немає
  }
  if (!isJsonResponse(res)) {
    throw new BackendUnavailableError('non-json response');
  }
  return res.json();
}
